module.exports = __webpack_public_path__ + "static/media/list.82de7fd3.svg";